import styles from "./style.module.css";

type Props = {
  title: string;
  subtitle: string;
};
export const BreadcrumbChildHeader = ({ title, subtitle }: Props) => {
  return (
    <div className={styles.header}>
      <h2 className={styles.title}>{title}</h2>
      <small>{subtitle}</small>
    </div>
  );
};
